/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-04-21 11:44:29
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2026-03-30 10:25:10
 * @FilePath: /designcenter/src/api/modules/templateManange.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getApiRequest } from '@/utils'
import type { IRes } from '@/types'

const request = getApiRequest()

/**
 * 创建或修改项目的请求参数
 */
export interface CreateProjectParams {
  /** 项目id(新增时为空，修改时必传) */
  id?: number
  /** 模板id */
  templateId?: number
  /** 是否自定义（0.否；1.是） */
  isCustomized?: 0 | 1
  /** 项目名称 */
  name: string
  /** 项目描述 */
  description?: string
}

/**
 * 创建或修改项目
 * @param data 请求参数
 * @returns 返回项目ID
 */
export async function createProject(data: CreateProjectParams) {
  return request.post<IRes<number>>('/design/project/edit', data)
}

/**
 * 创建新拓扑图的请求参数
 */
export interface CreateNewDiagParams {
  /** 项目ID */
  projectId: number
  /** 模板ID */
  templateId: number
  [key: string]: unknown
}

/**
 * 切换模板创建新项目拓扑图
 * @param data 请求参数
 * @returns 返回拓扑图数据
 */
export async function createNewDiag(data: CreateNewDiagParams) {
  return request.post<IRes<unknown>>('/design/topology/createNewDiag', data)
}

/**
 * 复制项目拓扑图的请求参数
 */
export interface CopyDiagramParams {
  /** 项目ID */
  projectId: number
  [key: string]: unknown
}

/**
 * 创建被分享项目副本
 * @param data 请求参数
 * @returns 返回拓扑图数据
 */
export async function copyDiagram(data: CopyDiagramParams) {
  return request.post<IRes<unknown>>('/design/topology/copyDiagram', data)
}

/**
 * 查询模板分类列表
 * @returns 返回模板列表
 */
export async function getTemplatePopupList(params: any) {
  return request.get<IRes<unknown>>('/design/template/list', { params })
}

/**
 * 分页查询项目列表的请求参数
 */
export interface ProjectListQueryParams {
  /** 每页条数 */
  size?: number
  /** 当前页数 */
  current?: number
  /** 项目名称 */
  name?: string
  /** 开始时间 */
  startTime?: string
  /** 结束时间 */
  endTime?: string
  /** 创建时间排序(1.升序 2.降序) */
  timeSort?: 1 | 2
}

/**
 * 分页查询项目列表
 * @param data 请求参数
 * @returns 返回分页项目列表
 */
export async function getProjectList(data: ProjectListQueryParams) {
  return request.post<IRes<unknown>>('/design/project/page', data)
}

/**
 * 查询项目详情的请求参数
 */
export interface GetProjectDetailParams {
  /** 项目ID */
  id: number
}

/**
 * 查询项目详情
 * @param data 请求参数
 * @returns 返回项目详情
 */
export async function getProjectDetail(data: GetProjectDetailParams) {
  return request.get<IRes<unknown>>('/design/project/detail', { params: data })
}

/**
 * 项目绑定模板的请求参数
 */
export interface BindTemplateParams {
  /** 项目ID */
  projectId: number
  /** 模板ID */
  templateId: number
  [key: string]: unknown
}

/**
 * 项目绑定模板
 * @param data 请求参数
 * @returns 返回绑定结果
 */
export async function bindTemplate(data: BindTemplateParams) {
  return request.post<IRes<number>>('/design/topology/bind', data)
}

/**
 * 删除项目的请求参数
 */
export interface DeleteProjectParams {
  /** 项目ID集合 */
  ids: number[]
}

/**
 * 删除项目
 * @param data 请求参数
 * @returns 返回删除结果
 */
export async function deleteProjectList(data: DeleteProjectParams) {
  return request.post<IRes<boolean>>('/design/project/remove', data)
}

/**
 * 分享项目的请求参数
 */
export interface ShareProjectParams {
  /** 项目ID */
  projectId: number
  /** 邮箱地址列表 */
  emailAddress: string[]
}

/**
 * 分享项目
 * @param data 请求参数
 * @returns 返回分享结果
 */
export async function shareProject(data: ShareProjectParams) {
  return request.post<IRes<string>>('/design/email/share', data)
}

//分享项目
export async function uploadImage(data: FormData) {
  return request.post<IRes<unknown>>('/design/file-upload/add', data)
}

//获取国家列表
export async function getCountryList() {
  return request.get<IRes<unknown>>('/design/country/list')
}

//客户 pdf
export async function exportCustomerPdf(data: unknown) {
  return request.post<IRes<unknown>>('/design/export/customer/pdf', data, {
    responseType: 'blob',
  })
}

//技术 pdf
export async function exportTechnologyPdf(data: unknown) {
  return request.post<IRes<unknown>>('/design/export/technology/pdf', data, {
    responseType: 'blob',
  })
}

//初始化项目
export async function initProject() {
  return request.get<IRes<unknown>>('/design/project/entry')
}

//查询用户是否被引导
export async function getUserGuide() {
  return request.get<IRes<unknown>>('/design/project/guide')
}

//设置用户引导
export async function setUserGuide() {
  return request.post<IRes<unknown>>('/design/project/setGuide')
}

interface GetShareParams {
  projectId: number
}
//生成分享链接
export async function getShareUrl(params: GetShareParams, config?: AxiosRequestConfig) {
  return request.get<IRes<unknown>>('/design/project/generateShareUrl', { ...config, params })
}

/**
 * 设置项目是否允许复制副本的请求参数
 */
export interface SetCopyStatusParams {
  /** 项目ID */
  projectId: number
  /** 是否允许被复制副本(0.否；1.是) */
  isAllowCopy: 0 | 1
}

/**
 * 设置项目是否允许复制副本
 * @param data 请求参数
 * @returns 返回布尔值表示操作是否成功
 */
export async function setCopyStatus(data: SetCopyStatusParams) {
  return request.post<IRes<boolean>>('/design/project/setCopyStatus', data)
}

/**
 * 项目协作者角色枚举
 */
export enum CollaboratorRole {
  /** 所有者 */
  Owner = 1,
  /** 查看者 */
  Viewer = 2,
  /** 编辑者 */
  Editor = 3,
}

/**
 * 项目协作者信息
 */
export interface ProjectCollaborator {
  /** 主键ID */
  id: number
  /** 协作者名称 */
  name: string
  /** 协作者邮箱 */
  email: string
  /** 协作者角色(1.Owner;2.Viewer;3.Editor) */
  role: CollaboratorRole
}

/**
 * 查看项目协作者列表的请求参数
 */
export interface GetCollaboratorListParams {
  /** 项目ID */
  projectId: number
}

/**
 * 查看项目协作者列表
 * @param params 请求参数
 * @returns 返回协作者列表
 */
export async function getCollaboratorList(params: GetCollaboratorListParams) {
  return request.get<IRes<ProjectCollaborator[]>>('/design/project/collaborator-list', { params })
}

/**
 * 检查项目是否已删除的请求参数
 */
export interface CheckProjectDeletedParams {
  /** 项目ID */
  id: string
}

/**
 * 检查项目是否已删除
 * @param params 请求参数
 * @returns 返回布尔值，true表示已删除，false表示未删除
 */
export async function checkProjectDeleted(params: CheckProjectDeletedParams) {
  return request.get<IRes<boolean>>('/design/project/checkDel', { params })
}

/**
 * 删除协作者的请求参数
 */
export interface RemoveCollaboratorParams {
  /** 协作者主键ID */
  id: number
}

/**
 * 删除协作者
 * @param params 请求参数
 * @returns 返回布尔值表示操作是否成功
 */
export async function removeCollaborator(params: RemoveCollaboratorParams) {
  return request.delete<IRes<boolean>>('/design/project/remove-collaborator', { params })
}

/**
 * 项目查看权限类型枚举
 */
export enum ProjectRuleType {
  /** 所有人可看 */
  Public = 1,
  /** 项目协作人可看 */
  Collaborators = 2,
}

/**
 * 设置项目查看类型的请求参数
 */
export interface SetProjectRuleTypeParams {
  /** 项目ID */
  projectId: number
  /** 查看权限类型(1.所有人可看；2.项目协作人可看) */
  ruleType: ProjectRuleType
}

/**
 * 设置项目查看类型
 * @param data 请求参数
 * @returns 返回布尔值表示操作是否成功
 */
export async function setProjectRuleType(data: SetProjectRuleTypeParams) {
  return request.post<IRes<boolean>>('/design/project/setRuleType', data)
}

export interface ProjectDuplicateParams {
  /** 项目ID */
  projectId: number
}
export async function projectDuplicate(params: ProjectDuplicateParams) {
  return request.post<IRes<boolean>>('/design/project/duplicate', null, { params })
}
